import { useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import { ApplyContext } from "@/context";
import useLenis from "@/hooks/useLenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Modules from "@/components/Modules";
import Languages from "@/components/Languages";
import WhyChooseUs from "@/components/WhyChooseUs";
import Manifesto from "@/components/Manifesto";
import Impact from "@/components/Impact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ApplyModal from "@/components/ApplyModal";

export default function UnnatiAi() {
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState("");
  useLenis();

  const openApply = (module = "") => {
    setPreset(module);
    setOpen(true);
  };

  return (
    <ApplyContext.Provider value={{ openApply }}>
      <div className="bg-light-gray text-deep-trust-blue font-body antialiased">
        <Header />
        <main>
          <Hero />
          <TrustBar />
          <Modules />
          <Languages />
          <WhyChooseUs />
          <Manifesto />
          <Impact />
        </main>
        <Footer />
        <WhatsAppButton />
        <ApplyModal open={open} setOpen={setOpen} preset={preset} />
        <Toaster position="top-center" richColors />
      </div>
    </ApplyContext.Provider>
  );
}
